import Brewing from './Brewing.webp';
import Clear from './Clear.webp';
import Fail from './Fail.webp';
import Ingredients from './Ingredients.webp';
import Title from './Title.webp';

export default {
    Brewing,
    Clear,
    Fail,
    Ingredients,
    Title
}